
































































import { IOvertimeRequest, OvertimeRequestStateEnum } from '@/models';
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'OvertimeApproverList',

  props: {
    overtime: {
      type: Object as () => IOvertimeRequest,
      required: true
    }
  },
  data() {
    return {
      OvertimeRequestStateEnum
    };
  },
  methods: {
    moment
  }
});
